import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";
import type { IFilterViewBaseModelProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";
import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";
import type { IAppsAndroidIdentifierFilter } from "app/pages/sales-intelligence/store/find-apps/types";

import { FlexRowWrap } from "../styles";

export const AppsAndroidIdentifiersFilterResult: FC<IFilterViewBaseModelProps<IAppsAndroidIdentifierFilter>> = ({
    value,
    onFilterUpdate,
    isExpanded,
}) => {
    const handleDelete = (id: string) => {
        const updatedValues = value?.packageNames.filter((item) => item !== id) ?? [];
        onFilterUpdate(updatedValues.length ? { packageNames: updatedValues } : undefined);
    };

    const chipItems = value?.packageNames?.map((item) => ({ text: item, id: item })) ?? [];

    if (!value?.packageNames?.length) {
        return null;
    }

    return (
        <FlexRowWrap>
            <LimitedChipItems
                items={chipItems}
                onDelete={handleDelete}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                delimiter={translate("si.find_apps.filters.identifier.OR")}
                isTabExpanded={isExpanded}
            />
        </FlexRowWrap>
    );
};
